/**
 * Created by Christof Sander on 08.09.2016.
 */

// TODO: maybe implement categories preloading within this store
const utils = require('./../lib/utils');
var appConfig = require('../lib/config').getConfig();
var ComponentTree = require('../lib/componentTree');

const CONTAINER_VERSION = (process.env || {}).VERSION || '0.0.0';

module.exports = {
	// this is a list of sessions (the key is the sessionID)
	sessions: {},
	// this is a list of sessionID dependent request storages
	requests: {},
	// this is the list of service dependent data (the key is <serviceDomain>)
	apps: {},
	// this is a list of componentTree instances for each service (the key is <realServiceDomain>) NOTE: means api-auth-domain
	componentTrees: {},

	// this is a list of default values used for server side entries.
	defaults: {
		request: {
			preparedRequestList: {},
			preparedRequestCollectionList: {}
		},
		session: {
			usageCounter: 0
		},
		app: {
			version: CONTAINER_VERSION,
			nrOfActiveRequests: 0,
			nrOfPausedRequests: 0,
			privileges: {},
			categories: {
				own: {},
				foreign: {}
			},
			service: {
				availableLangCodes: {}
			},
			persistent: {
				resetPasswords: {}
			},
			fullAppInits: {},
			routes: {},
			cache: {
				gateways: 			{},
				defaultScope: 		{},
				routesScope: 		{},
				tagsScope: 			{},
				menusScope: 		{},
				categoriesScope: 	{},
				forwards: 			{}
			},
			// register of pending activations used by activateCredentials and registerCredentials
			activationRegister: {},
			// project dependent, non-persistent storage
			project: {},
		}
	},
	// this is the demo specific data which is only used within demo components or resources
	demo: {},

	// this is an object list of storage elements (the key is <sessionID>_<serviceDomain>)
	// NOTE: a storage object contains references to the original data within the other lists and some extra data (like sessionID)
	storages: {},

	/**
	 * this function will be called once on store init and should be overwritten by client- or server-specific code.
	 */
	init: function(){
		// NOTE: overwritten by client || server
	},

	/**
	 * this function will be called before each store.set and should be overwritten by client- or server-specific code.
	 */
	beforeSet: function(){
		// NOTE: overwritten by client || server
	},

	/**
	 * this function will be called after each store.set and should be overwritten by client- or server-specific code.
	 */
	afterSet: function(){
		// NOTE: overwritten by client || server
	},

	/**
	 * this function will be called each time store.get will be called.
	 * it can modify the storage and has to return it afterwards.
	 * NOTE: it should be overwritten by client- or server-specific code.
	 *
	 * @param   storage     {} - actual storage
	 * @returns storage
	 */
	sanitizeStorage: function(storage){
		// NOTE: overwritten by client || server
	},

	/**
	 * this function returns the storage according to a given sessionID and serviceDomain.
	 * NOTE: this function should no be called externally. Use get-method instead.
	 *
	 * @param   requestID               string - requestID (can be empty if used on client-side)
	 * @param   sessionID               string - sessionID (can be empty if used on client-side)
	 * @param   serviceDomain           string - serviceDomain (can be empty if used on client-side)
	 * @param   incrementUsageCounter   boolean - should the usageCounter be incremented or not
	 * @returns storage
	 */
	getStorage: function(requestID, sessionID, serviceDomain, incrementUsageCounter){
		if(sessionID){
			if(!this.sessions[sessionID]){
				this.sessions[sessionID] = utils.simpleCopy(this.defaults.session);
			}
			if(incrementUsageCounter){
				this.sessions[sessionID].usageCounter++;
			}
			if(requestID){
				if(!this.requests[sessionID]){
					this.requests[sessionID] = {};
				}
				if(!this.requests[sessionID][requestID]){
					this.requests[sessionID][requestID] = utils.merge(this.defaults.request, { requestID: requestID });
				}
			}
		}

		if(serviceDomain){
			var storageKey = (requestID || 'request') + '_' + (sessionID || 'session') + '_' + serviceDomain;
			var realServiceDomain;

			if(appConfig.isServer){
				if(appConfig.services[serviceDomain]){
					realServiceDomain = appConfig.services[serviceDomain]['api-auth-domain'];
				} else {
					console.error('SERVICE_DOMAIN_NOT_FOUND', serviceDomain, appConfig.services);
					realServiceDomain = 'UNKNOWN_API_AUTH_DOMAIN';
				}
			}
			else {
				realServiceDomain = serviceDomain;
			}

			if(!this.apps[serviceDomain]){
				this.apps[serviceDomain] = utils.simpleCopy(this.defaults.app);
				this.apps[serviceDomain].upStartTimestamp = this.upStartTimestamp;
			}

			if(!this.storages[storageKey] || !this.storages[storageKey].app){

				if(!this.componentTrees[realServiceDomain]) this.componentTrees[realServiceDomain] = new ComponentTree();

				this.storages[storageKey] = {
					app:                this.apps[serviceDomain],
					componentTree:      this.componentTrees[realServiceDomain],
					requestID:          requestID,
					request: 			(this.requests[sessionID] || {})[requestID] || {},
					sessionID:          sessionID,
					session:            this.sessions[sessionID] || {},
					// storage should know if it is a server- or a client-storage
					isServer:           !!this.isServer,
					isClient:           !!this.isClient,
					realServiceDomain:  realServiceDomain,
					serviceDomain:  	serviceDomain,
				};

				if(appConfig.isServer){
					var self = this;
					this.storages[storageKey].filterClientData = function(){
						if(typeof(self.filterClientData) === 'function') return self.filterClientData(self.storages[storageKey]);
						return {};
					}
				}
			}

			return this.sanitizeStorage(this.storages[storageKey]);
		}

		return {};
	},

	/**
	 * this function is used to overwrite the data stored within one specific storage.
	 * NOTE: this function should no be called externally. Use set-method instead.
	 *
	 * @param   data            		{} - data to write to the store
	 * @param   requestID       		string - requestID (can be empty if used on client-side)
	 * @param   sessionID       		string - sessionID (can be empty if used on client-side)
	 * @param   serviceDomain   		string - serviceDomain (can be empty if used on client-side)
	 * @param   resetApp        		boolean - should the app be reseted by defaults
	 * @param   updateServer			boolean - default: false - should the server be update according to the given data
	 * @param   updateServerCallback	object - optional - { function: <callbackFunction>, context: <callbackContext> }
	 * @returns storage
	 */
	setStorage: function(data, requestID, sessionID, serviceDomain, resetApp, updateServer, updateServerCallback){
		var storage = this.getStorage(requestID, sessionID, serviceDomain);

		// never set usageCounter according to real request session data
		// NOTE:    this usageCounter is used to prevent closeSession-calls from killing the "in-request-store-entries"
		//          in case of multiple parallel requests sent within one session
		if(data && data.session) delete data.session.usageCounter;

		// reset app value if necessary
		if(resetApp){
			utils.refReplace(storage.app, utils.simpleCopy(this.defaults.app || {}));
		}

		this.beforeSet(storage, data);
		utils.refMerge(storage, data);
		this.afterSet(storage, updateServer, updateServerCallback);
		return this.sanitizeStorage(storage);
	},

	/**
	 * this function returns the actual storage according to the given parameters.
	 *
	 * @param   requestID               string - requestID (can be empty if used on client-side)
	 * @param   sessionID               string - sessionID (can be empty if used on client-side)
	 * @param   serviceDomain           string - serviceDomain (can be empty if used on client-side)
	 * @param   incrementUsageCounter   boolean - should the usageCounter be incremented or not
	 * @returns storage
	 */
	get: function(requestID, sessionID, serviceDomain, incrementUsageCounter){
		sessionID = sessionID || appConfig.sessionIDFallback;
		requestID = requestID || appConfig.requestIDFallback;
		serviceDomain = utils.hostToDomain(serviceDomain || appConfig.serviceDomainFallback);

		return this.getStorage(requestID, sessionID, serviceDomain, incrementUsageCounter);
	},

	/**
	 * this function is used to write some data to the storage identified by the given parameters.
	 *
	 * @param   data            		{} - data to write to the store
	 * @param   requestID       		string - requestID (can be empty if used on client-side)
	 * @param   sessionID       		string - sessionID (can be empty if used on client-side)
	 * @param   serviceDomain   		string - serviceDomain (can be empty if used on client-side)
	 * @param   resetApp        		boolean - should the app be reseted by defaults
	 * @param   updateServer			boolean - default: true - should the servers' storage be updated according to the given data
	 * @param   updateServerCallback	object - optional - { function: <callbackFunction>, context: <callbackContext> }
	 * @returns storage
	 */
	set: function(data, requestID, sessionID, serviceDomain, resetApp, updateServer, updateServerCallback){
		sessionID = sessionID || appConfig.sessionIDFallback;
		requestID = requestID || appConfig.requestIDFallback;
		serviceDomain = utils.hostToDomain(serviceDomain || appConfig.serviceDomainFallback);
		resetApp = !!resetApp;

		return this.setStorage(data, requestID, sessionID, serviceDomain, resetApp, updateServer === undefined || !!updateServer, updateServerCallback);
	},

	/**
	 * this function is used to remove the data stored within the given storage and
	 * the corresponding reference lists.
	 *
	 * @param   storage         					{} - actual storage
	 * @param   sessionID       					string - sessionID (can be empty if used on client-side)
	 * @param   serviceDomain   					string - serviceDomain (can be empty if used on client-side)
	 * @param   [deleteThisStorageOnly=false] 		boolean - should only the given storage or all storages (according to the sessionID) be deleted?
	 */
	remove: function(storage, sessionID, serviceDomain, deleteThisStorageOnly){
		utils.forEach(storage, function(element, elementKey){
			if(elementKey != 'componentTree') delete storage[elementKey];
		});
		if(!deleteThisStorageOnly && sessionID){
			var self = this;
			utils.forEach(self.storages, function(otherStorage, otherStorageKey){
				if((otherStorage || {}).sessionID === sessionID){
					self.remove(self.storages[otherStorageKey], sessionID, serviceDomain, true);
				}
			});
			delete this.sessions[sessionID];
		}
		delete storage;
	},

	/**
	 * this function is used to remove the request dependent data stored within the given storage and
	 * the corresponding reference lists.
	 *
	 * @param   storage 		{} - actual storage
	 */
	removeRequest: function(storage){
		if((storage || {}).requestID && storage.sessionID){
			// remove this request from store
			if((this.requests[storage.sessionID] || {})[storage.requestID]){
				delete this.requests[storage.sessionID][storage.requestID];
			}

			// remove empty requests within this session from store
			if(this.requests[storage.sessionID] && Object.keys(this.requests[storage.sessionID] || {}).length <= 0) {
				delete this.requests[storage.sessionID];
			}

			// remove this requests' storage from store
			var storageKey = (storage.requestID || 'request') + '_' + (storage.sessionID || 'session') + '_' + storage.serviceDomain;
			if(this.storages[storageKey]){
				delete this.storages[storageKey];
			}
		}
	}
};